var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"group px-4 py-2 focus:outline-none w-full text-left text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900",attrs:{"type":"button","role":"menuitem"},on:{"click":_vm.execute}},[_c('p',[_vm._v("Send Order to "+_vm._s(_vm.serviceName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }